import DOMPurify from 'dompurify';
import marked from 'marked'


export const markdown = function (text) {
  const rawHtml = marked(text)
  return DOMPurify.sanitize(rawHtml)
}

export const focus = function (el) {
  el.focus()
}
